var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ribbon" },
    [
      !_vm.isDataLoaded
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _c("div", { staticClass: "flex-container pl-2 pr-2" }, [
            _c("div", { staticClass: "flex-col flex-10" }, [
              _c("div", { staticClass: "flex-row" }, [
                _c("div", { staticClass: "flex-col" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("selectAsset")))]),
                  _c(
                    "div",
                    { staticClass: "flex-row flex-1" },
                    [
                      _c("SelectDropdown", {
                        staticClass: "select",
                        staticStyle: { width: "30rem" },
                        attrs: {
                          options: _vm.assets,
                          default: _vm.assetselection,
                          displayKey: "name",
                        },
                        on: { input: _vm.onSelectAsset },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "mr-2" }),
                _vm.hasEditAccess
                  ? _c("div", { staticClass: "flex-col" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("selectCalculationDate"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-row flex-1" },
                        [
                          _c("dropdown", {
                            attrs: {
                              itemList: _vm.runIds,
                              defaultRunId: _vm.runIdSelection,
                            },
                            on: { "selected-runid": _vm.onRunIdSelect },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.hasEditAccess
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-col pl-2 justify-end",
                        staticStyle: { "padding-bottom": "0.32rem" },
                      },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.runIdSelection.isFinal,
                                expression: "!runIdSelection.isFinal",
                              },
                            ],
                            staticClass: "btn",
                            on: { click: () => (_vm.shouldShowConfirm = true) },
                          },
                          [_vm._v(_vm._s(_vm.$t("markAsFinal")) + " ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.hasDataFreezeAccess && !_vm.runIdSelection.isDataFreeze
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-col pl-2 justify-end",
                        staticStyle: { "padding-bottom": "0.32rem" },
                      },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.runIdSelection.isFinal,
                                expression: "runIdSelection.isFinal",
                              },
                            ],
                            staticClass: "btn",
                            on: {
                              click: () => (_vm.dataFreezeConfirmModal = true),
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("freezeData")) + " ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.hasDataFreezeAccess && _vm.runIdSelection.isDataFreeze
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-col pl-2 justify-end",
                        staticStyle: { "padding-bottom": "0.32rem" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: () =>
                                (_vm.dataUnfreezeConfirmModal = true),
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("unfreezeData")) + " ")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.hasEditAccess
                  ? _c(
                      "div",
                      {
                        staticClass: "flex-col pl-2 justify-end",
                        staticStyle: { "padding-bottom": "0.32rem" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.openModal()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("runCalculation")) + " ")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "flex-col flex-3 justify-end" }, [
              _c(
                "div",
                { staticClass: "flex-row reverse" },
                [
                  _vm.isDataLoaded
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-col",
                          on: {
                            click: function ($event) {
                              return _vm.onUiToggle()
                            },
                          },
                        },
                        [
                          _c("div", { class: _vm.togglerClasses }, [
                            _c(
                              "div",
                              { staticClass: "flex-col flex-1 toggle-text" },
                              [_vm._v(_vm._s(_vm.isNewUi ? "I" : "II"))]
                            ),
                            _c("div", {
                              staticClass: "flex-col flex-1 toggle-switch",
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "separator" }),
                  _c(
                    "router-link",
                    {
                      staticClass: "flex-col justify-end goto-download",
                      attrs: { to: "/final-report" },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "download"] },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("finalReport")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
      _vm.hasEditAccess
        ? _c("confirm-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shouldShowConfirm,
                expression: "shouldShowConfirm",
              },
            ],
            attrs: {
              item: { sNo: this.runIdSelection.sNo },
              message: "areYouSureToMarkFinal",
            },
            on: {
              "confirm-action": _vm.markAsFinal,
              "cancel-action": () => (_vm.shouldShowConfirm = false),
            },
          })
        : _vm._e(),
      _vm.hasViewAccess
        ? _c("confirm-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataFreezeConfirmModal,
                expression: "dataFreezeConfirmModal",
              },
            ],
            attrs: {
              item: { sno: this.runIdSelection.sNo, isDataFreeze: true },
              message: "areYouSureToFreezeTheData",
            },
            on: {
              "confirm-action": _vm.dataFreeze,
              "cancel-action": () => (_vm.dataFreezeConfirmModal = false),
            },
          })
        : _vm._e(),
      _vm.hasViewAccess
        ? _c("confirm-modal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataUnfreezeConfirmModal,
                expression: "dataUnfreezeConfirmModal",
              },
            ],
            attrs: {
              item: { sno: this.runIdSelection.sNo },
              message: "areYouSureToUnfreezeTheData",
            },
            on: {
              "confirm-action": _vm.dataUnfreeze,
              "cancel-action": () => (_vm.dataUnfreezeConfirmModal = false),
            },
          })
        : _vm._e(),
      _vm.showDataFreezeModal
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.showDataFreezeModal, width: "auto" },
              domProps: {
                onClose: () => (_vm.showDataFreezeModal = false),
                enableHeader: false,
                enableFooter: false,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c("span", [
                !_vm.errorExist
                  ? _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("div", { staticClass: "flex-col pr-1" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("dataFreezedSuccessfully")) + " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-col flex-justify-center" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "check-circle fa-lg",
                            attrs: { icon: ["fas", "check-circle"] },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("div", { staticClass: "flex-col pr-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("errorFreezingData")) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-col" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "times-circle fa-lg",
                            attrs: { icon: ["fas", "times-circle"] },
                          }),
                        ],
                        1
                      ),
                    ]),
                _c("div", { staticClass: "flex-row flex-1 reverse mt-1" }, [
                  _c("div", { staticClass: "flex-col" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn mt-1",
                        on: { click: () => (_vm.showDataFreezeModal = false) },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("ok")) + " ")]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showDataUnfreezeModal
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.showDataUnfreezeModal, width: "auto" },
              domProps: {
                onClose: () => (_vm.showDataUnfreezeModal = false),
                enableHeader: false,
                enableFooter: false,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c("span", [
                !_vm.errorExist
                  ? _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("div", { staticClass: "flex-col pr-1" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dataUnfreezedSuccessfully")) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-col flex-justify-center" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "check-circle fa-lg",
                            attrs: { icon: ["fas", "check-circle"] },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("div", { staticClass: "flex-col pr-1" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("errorUnfreezingData")) + " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-col" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "times-circle fa-lg",
                            attrs: { icon: ["fas", "times-circle"] },
                          }),
                        ],
                        1
                      ),
                    ]),
                _c("div", { staticClass: "flex-row flex-1 reverse mt-1" }, [
                  _c("div", { staticClass: "flex-col" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn mt-1",
                        on: {
                          click: () => (_vm.showDataUnfreezeModal = false),
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("ok")) + " ")]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }